<template lang="pug">
  button.scroll-top-button(type="button", :class="{ 'scroll-top-button_show' : isVisible }", @click="scrollToTop")
</template>

<script>
import '@/assets/styles/components/scroll-top-button.sass'

export default {
  name: 'TheScrollTopButton',
  data () {
    return {
      rafId: null,
      lastScrollPosition: null,
      isVisible: false
    }
  },
  methods: {
    scrollToTop () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    handleScroll () {
      if (this.rafId) return

      this.rafId = requestAnimationFrame(() => {
        const currentScrollPosition = window.scrollY

        if (currentScrollPosition > 100 && !this.isVisible) {
          this.isVisible = true
        } else if (currentScrollPosition <= 100 && this.isVisible) {
          this.isVisible = false
        }

        this.lastScrollPosition = currentScrollPosition
        this.rafId = null
      })
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll, { passive: true })
    this.handleScroll()
  },
  unmounted () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>
